import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[mat-tab-group-headerless]',
})
export class MatTabGroupHeaderlessDirective implements OnInit {
  constructor(private eleRef: ElementRef) {}

  ngOnInit(): void {
    this.eleRef.nativeElement.children[0].style.display = 'none';
  }
}
